import { Text } from "@certn/cascadia";
import { useTranslation } from "react-i18next";

import { AddressProps } from "../../../../src/schemas-and-types";

export const CustomerAddress = (props: AddressProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Text style="global/heading-medium">{t("Bill to")}</Text>
      <Text style="global/body-primary">
        {props.name}
        {props.isClient && (
          <>
            <br />
            {props.street}
            <br />
            {props.city}, {props.province}
            <br />
            {props.postalCode}
            <br />
            {props.country}
            <br />
          </>
        )}
      </Text>
    </>
  );
};
